import Toastr from "../../../../itrust_common/components/Toastr"

const DEFAULT_STATE = {
  saving: false,
  ai_receptionist_addon: {}
}

let changes = null
export const aiReceptionistReducer = (state = DEFAULT_STATE, action) => {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {

    case 'AI_RECEPTIONIST_ADDON_LOAD_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = { saving: false }
      return { ...state, ...changes };

    case 'AI_RECEPTIONIST_ADDON_LOAD_FULFILLED':
      changes = {
        ai_receptionist_addon: response.add_ons?.[0],
        saving: false
      };
      return { ...state, ...changes }

    case 'AI_RECEPTIONIST_ADDON_UPDATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      changes = {
        ai_receptionist_addon: response.add_on,
        saving: false
      };
      return { ...state, ...changes }

    default:
      return state
  }
}